import { useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getKhattabat102Store from "../../../../../../stores/khattabat-stores/102-stores";

const KhattabatOneOTwoQuality = withLiteObserverAndTheme<{
  oneOTwoConversationId: string;
}>((props) => {
  const { oneOTwoConversationId } = props;
  const {
    manualIsQuality,
    shouldSetOneOTwoToQuality,
    toggleOneTwoQualityState
  } = getKhattabat102Store(oneOTwoConversationId);
  useEffect(() => {
    shouldSetOneOTwoToQuality();
  });

  return (
    <FormControlLabel
      label={i18n.get("QUALITY")}
      slotProps={{ typography: { variant: "body2" } }}
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
      control={
        <Checkbox
          size="small"
          color="success"
          checked={isPositiveNumber(manualIsQuality.get())}
          onChange={async () => {
            await toggleOneTwoQualityState({
              isAuto: 0
            });
          }}
        />
      }
    />
  );
});

export default KhattabatOneOTwoQuality;
